import { Typography, useTheme } from '@mui/material'
import { highlightVariables } from 'src/common/utils'
import { ESettingsPromptFields } from 'src/types'
import { getHighlightVariableForField } from '../settings.utils'

interface IProps {
  field: ESettingsPromptFields
  description: string
}

export const SettinsFieldDescription = ({ field, description }: IProps) => {
  const theme = useTheme()
  const variableToHighlight = getHighlightVariableForField(field)

  return (
    <Typography
      sx={{
        fontSize: '12px',
        color: theme.palette.text.secondary,
        px: '8px',
        maxWidth: '400px',
        whiteSpace: 'pre-wrap',
      }}
    >
      {variableToHighlight ? highlightVariables(description, variableToHighlight) : description}
    </Typography>
  )
}
